import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    unsubscriptMember: function (token) {
        var strUrl = `${this.config().bzbsUrl}/consent/unconsent`;
        return BzbsApi.connectBzbsPost(strUrl, token);
    }
}
